<template>
  <header class="page-project-header">
    <!-- Title -->
    <h1 class="text-xl-1" data-animate="preloader-reveal">
      <strong>{{ props.project.title }}</strong>
    </h1>

    <!-- Subtitle -->
    <p
      class="text-xl-1"
      v-if="props.project.subtitle"
      data-animate="preloader-reveal"
    >
      {{ props.project.subtitle }}
    </p>

    <!-- Tags -->
    <div
      data-animate="preloader-opacity"
      class="m-top-1 button-tag-list show-for-large"
      v-if="
        props.project.industryTag?.length || props.project.technologyTag?.length
      "
    >
      <!-- Industry -->
      <PagesProjectTagList
        v-if="props.project.industryTag?.length"
        :tags="props.project.industryTag"
        :query="'industry'"
      />
      <!-- Technology -->
      <PagesProjectTagList
        v-if="props.project.technologyTag?.length"
        :tags="props.project.technologyTag"
        :query="'technology'"
      />
    </div>
  </header>
</template>

<script>
export default {
  name: 'PagesProjectHeader',
}
</script>

<script setup>
const props = defineProps({
  project: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
